import { useState, useEffect } from 'react';
import { api } from '../lib/api';
import { ProposalsTable } from '../components/ProposalsTable';
import { PaginationControls } from '../components/PaginationControls';

interface Proposal {
  id: string;
  title: string;
  department: string;
  status: string;
  submitter_name: string;
  submitted_at: string;
  created_at: string;
  urgency: string;
}

const PAGE_SIZE = 20;

export function ProposalsPage() {
  const [proposals, setProposals] = useState<Proposal[]>([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    const fetchProposals = async () => {
      setLoading(true);
      try {
        const res = await api.get<{ proposals: Proposal[]; pagination: { total: number } }>(
          `/proposals?page=${page}&limit=${PAGE_SIZE}`
        );
        setProposals(res.proposals);
        setTotal(res.pagination.total);
      } catch (err) {
        console.error(err);
      }
      setLoading(false);
    };
    fetchProposals();
  }, [page]);

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold tracking-tight">All Proposals</h1>

      {loading ? (
        <p className="text-muted-foreground">Loading...</p>
      ) : (
        <>
          <ProposalsTable proposals={proposals} showSubmitter={true} />
          <PaginationControls page={page} limit={PAGE_SIZE} total={total} onPageChange={setPage} />
        </>
      )}
    </div>
  );
}
